export enum LOCALE_STORAGE_KEYS {
  SITES = 'sites',
  USER = 'user',
  ACTIVATED = 'activated',
  LEVELS = 'levels',
  CART_WIDGET_COLLAPSED = 'cartWidgetCollapsed',
  SELECTED_CONSULTATION_STAFF = 'selectedConsultationStaff',
  SIDEBAR_VISIBLE = 'sidebarVisible',
  DRAW_COLOR = 'drawColor',
  PROCEDURE_COLOR_MAP = 'procedureColorMap',
  PIN_WIDTH = 'pinWidth',
  X_WIDTH = 'xWidth',
  LINE_WIDTH = 'lineWidth',
  INTAKE_LOCK = 'intakeLock',
  SCHEDULE_PREFERENCES = 'schedulePreferences',
  TEAM_CHAT_OPEN = 'teamChatOpen',
  TEAM_CHAT_POSITION = 'teamChatPosition',
  TEAM_CHAT_MUTED = 'teamChatMuted',
}

export enum SESSION_STORAGE_KEYS {
  SELECTED_SCHEDULE_ROOMS = 'selectedScheduleRooms',
  SHOW_CANCELED_SCHEDULES = 'showCanceledSchedules',
  HIDE_CANCELED_CHART_APPOINTMENTS = 'hideCanceledChartAppointments',
}
